import supabase from "@/services/supabaseClient.js";

const PHARMACY_ROLE_HINTS = new Set([
  "pharmacy",
  "pharmacist",
  "pharmd",
  "pharmacy_owner",
  "pharmacy_staff",
]);

export function normalizePharmacyRoleHint(value = "") {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return PHARMACY_ROLE_HINTS.has(normalized) ? "pharmacy" : "";
}

export async function persistPharmacyOnboardingIdentity({
  userId = "",
  email = "",
  roleHint = "",
  source = "pharmacy_onboarding",
  nextRoute = "/onboarding/pharmacy",
  eventName = "pharmacy_role_selected",
} = {}) {
  const cleanUserId = String(userId || "").trim();
  if (!cleanUserId) return false;

  const cleanRoleHint = String(roleHint || "pharmacy").trim().toLowerCase() || "pharmacy";
  const cleanNextRoute = String(nextRoute || "/onboarding/pharmacy").trim() || "/onboarding/pharmacy";
  const cleanSource = String(source || "pharmacy_onboarding").trim();

  const { error: roleError } = await supabase.rpc("persist_pharmacy_onboarding_identity", {
    target_user_id: cleanUserId,
    role_hint: cleanRoleHint,
    source: cleanSource,
    next_route: cleanNextRoute,
    event_name: eventName,
    email: String(email || "").trim().toLowerCase() || null,
  });

  if (roleError) throw roleError;

  return true;
}
